import { RecentConversation } from '../hooks/useRecentConversations';
import { POPULATION_AGENT_USERNAME } from '../constants';

export type ConversationEntry = Omit<RecentConversation, 'conversationId'> & {
  conversationId?: string;
};

export type FhirSubjectSearch = (args: {
  projectId: string;
  cohort?: string;
  body: { _id: string };
}) => Promise<{
  data?: { entry?: Array<{ resource?: fhir3.Patient }> };
}>;

const normalizePatientId = (value?: string) => {
  if (!value) return undefined;
  const trimmed = value.trim();
  if (!trimmed || trimmed === 'undefined' || trimmed === 'null') {
    return undefined;
  }
  return trimmed;
};

export const resolvePatientIdFromConversation = (conversation: {
  patientId?: string;
  userIds?: string[];
}) => {
  const direct = normalizePatientId(conversation.patientId);
  if (direct) return direct;
  const scopedUserId = conversation.userIds?.find(id =>
    id.startsWith('scope?subject='),
  );
  const scopedId = scopedUserId?.split('scope?subject=')[1];
  return normalizePatientId(scopedId);
};

export const ensurePopulationConversationId = (
  userIds: string[] | undefined,
) => {
  if (!userIds?.length) return userIds;
  if (!userIds.includes(POPULATION_AGENT_USERNAME)) return userIds;
  const hasConversationId = userIds.some(id =>
    id.startsWith('scope?conversation_id='),
  );
  const next = hasConversationId
    ? userIds
    : [...userIds, `scope?conversation_id=${Date.now()}`];
  return Array.from(new Set(next));
};
